import React from "react";
import { hero } from "../mock";

const Hero = () => {
  return (
    <section className="relative w-full h-[52vw] max-h-[760px] min-h-[320px] overflow-hidden bg-black">
      <img
        src={hero.image}
        alt="Maxima Racing Oils Powersports"
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent" />
      <div className="absolute bottom-8 left-6 md:bottom-16 md:left-16">
        <h1 className="heading-font text-white/25 text-[13vw] md:text-[8vw] leading-none tracking-tighter">
          {hero.title}
        </h1>
      </div>
    </section>
  );
};

export default Hero;
